<template>
  <el-dialog :visible="visible" :title="title" custom-class="with-title x-large" @close="close">
    <div class="serial-code-management" v-loading="loading">
      <serial-code-table
        v-if="tab === 'serial-code-table'"
        @change_tab="changeTab"
        ref="serialCodeTable"
        :isEdit="isEdit"
      ></serial-code-table>
      <serial-code-create
        v-if="tab === 'serial-code-create'"
        @change_tab="changeTab"
        :isEdit="isEdit"
        :isFormChanged.sync="isFormChanged"
      ></serial-code-create>
      <serial-code-used-import
        v-if="tab === 'serial-code-used-import'"
        @change_tab="changeTab"
        :isFormChanged.sync="isFormChanged"
      ></serial-code-used-import>
      <serial-code-used-resets
        v-if="tab === 'serial-code-used-resets'"
        @change_tab="changeTab"
      ></serial-code-used-resets>
      <serial-code-unassigned-delete
        v-if="tab === 'serial-code-unassigned-delete'"
        @change_tab="changeTab"
        :isEdit="isEdit"
      ></serial-code-unassigned-delete>
    </div>
  </el-dialog>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import SerialCodeCreate from '@/client/features/twitter_instantwin_message/serial_code_create'
import SerialCodeTable from '@/client/features/twitter_instantwin_message/serial_code_table'
import SerialCodeUnassignedDelete from '@/client/features/twitter_instantwin_message/serial_code_unassigned_delete'
import SerialCodeUsedImport from '@/client/features/twitter_instantwin_message/serial_code_used_import'
import SerialCodeUsedResets from '@/client/features/twitter_instantwin_message/serial_code_used_resets'
import { useTwitterInstantwinSerialCodeStore } from '@/client/store/useTwitterInstantwinSerialCodeStore'

export default defineComponent({
  data() {
    return {
      title: '',
      visible: false,
      tab: '',
      isEdit: false,
      isFormChanged: false
    }
  },
  components: {
    SerialCodeTable,
    SerialCodeCreate,
    SerialCodeUsedImport,
    SerialCodeUsedResets,
    SerialCodeUnassignedDelete
  },
  computed: {
    ...mapState(useTwitterInstantwinSerialCodeStore, {
      loading: state => state.loading
    })
  },
  methods: {
    ...mapActions(useTwitterInstantwinSerialCodeStore, ['fetchSerialCodeList', 'setCampaignId', 'reset']),

    changeTab(tab: string) {
      this.tab = tab
      this.isFormChanged = false
    },

    /**
     * ダイアログを開く
     * @param {number} campaignId
     * @param {string} messageName
     * @param {boolean} isEdit
     */
    open(campaignId: number, messageName: string, isEdit = false) {
      this.visible = true
      this.title = 'シリアルコードの管理'
      this.isEdit = isEdit
      this.tab = 'serial-code-table'

      this.setCampaignId(campaignId)

      if (messageName) {
        this.title += `(${messageName})`
      }
    },

    /**
     * ダイアログ閉じるイベント
     */
    close() {
      const confirmTabs = ['serial-code-create', 'serial-code-used-import']

      if (this.isFormChanged && confirmTabs.includes(this.tab)) {
        const message = '編集内容が保存されていません。ダイアログを閉じてよろしいですか?'
        const confirm = window.confirm(message)

        if (!confirm) {
          return
        }
      }

      this.visible = false
      this.tab = ''
      const serialCodeTable = this.$refs.serialCodeTable as InstanceType<typeof SerialCodeTable> | undefined
      if (serialCodeTable) {
        serialCodeTable.changeMessageId(0)
        serialCodeTable.changeStatus('')
      }
      this.reset()
    }
  }
})
</script>
